import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Component_PrettyPrint_Variadic.scss';
import { _className } from '@nu-art/thunderstorm-frontend';
import { BadImplementationException, exists } from '@nu-art/ts-common';
import { PPDescription, PPIndicatorStatus } from '../../Component_PrettyPrint_Description/Component_PrettyPrint_Description.js';
const getTitle = (operator) => {
    switch (operator) {
        case 'and':
            return 'All of the following:';
        case 'or':
            return 'Any of the following:';
        case 'addition':
            return 'Summary of the following:';
        case 'multiplication':
            return 'Multiplication of the following:';
        default:
            return `Unhandled Variadic case: ${operator}`;
    }
};
const getStatus = (operator, valueNode, interactive) => {
    if (!interactive)
        return;
    switch (operator) {
        case 'or':
        case 'and':
            return typeof valueNode?.value === 'boolean'
                ? (valueNode.value ? PPIndicatorStatus.pass : PPIndicatorStatus.fail)
                : PPIndicatorStatus.dataNeeded;
        case 'addition':
        case 'multiplication':
            return typeof valueNode?.value === 'number'
                ? PPIndicatorStatus.pass
                : PPIndicatorStatus.dataNeeded;
        default:
            return PPIndicatorStatus.dataNeeded;
    }
};
export const Component_PrettyPrint_Variadic = (props) => {
    if (exists(props.valueNode) && props.valueNode.type !== 'variadic')
        throw new BadImplementationException(`ValueTree_Node type mismatch: expected "variadic", got "${props.valueNode.type}"`);
    const status = getStatus(props.expression.operator, props.valueNode, props.interactive);
    const title = getTitle(props.expression.operator);
    const className = _className('variadic-description', status);
    if (!title)
        return _jsx(PPDescription, { className: className, "data-operator": props.expression.operator, children: _jsxs(PPDescription.Row, { children: [_jsx(PPDescription.Indicator, { status: status }), _jsxs(PPDescription.Title, { children: ["Unhandled Variadic case: ", props.expression.operator] })] }) });
    const elements = [];
    props.expression.operands.forEach((operand, index) => {
        const valueNode = props.valueNode?.operands[index];
        elements.push(_jsxs(PPDescription.Row, { children: [_jsx(PPDescription.TreeLineConnector, {}), props.descriptorRenderer(operand, valueNode)] }));
    });
    return _jsxs(PPDescription, { className: className, "data-operator": props.expression.operator, children: [_jsxs(PPDescription.Row, { children: [_jsx(PPDescription.Indicator, { status: status }), _jsx(PPDescription.Title, { children: title })] }), ...elements] });
};
//# sourceMappingURL=Component_PrettyPrint_Variadic.js.map